import React from 'react';
import { useMonthlyRotaForm } from '../context/MonthlyRotaContext';

const Step6Settings = () => {
  const { formData, updateField } = useMonthlyRotaForm();

  const ToggleSwitch = ({ checked, onChange }) => (
    <button 
      type="button"
      onClick={() => onChange(!checked)}
      className={`w-9 h-5 flex items-center rounded-full p-0.5 transition-colors duration-200 focus:outline-none ${checked ? 'bg-blue-600' : 'bg-gray-300'}`}
    >
      <div className={`bg-white w-3.5 h-3.5 rounded-full shadow transform transition-transform duration-200 ${checked ? 'translate-x-4' : 'translate-x-0'}`} />
    </button>
  );

  return (
    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
      <div className="flex items-center gap-2.5 mb-5">
        <div className="w-7 h-7 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold text-sm">6</div>
        <div>
          <h2 className="text-md font-bold text-gray-900">Additional Settings (Optional)</h2>
          <p className="text-[11px] text-gray-400">Set any additional options for this rota.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
        <div className="flex items-center justify-between border border-gray-200 p-2.5 rounded-md h-14 bg-white">
          <div>
            <p className="text-xs font-semibold text-gray-800">Allow staff to swap shifts?</p>
            <span className="text-[11px] text-gray-400">{formData.allowSwap ? 'Yes' : 'No'}</span>
          </div>
          <ToggleSwitch checked={formData.allowSwap} onChange={(val) => updateField('allowSwap', val)} />
        </div>

        <div className="flex items-center justify-between border border-gray-200 p-2.5 rounded-md h-14 bg-white">
          <div>
            <p className="text-xs font-semibold text-gray-800">Require manager approval?</p>
            <span className="text-[11px] text-gray-400">{formData.requireApproval ? 'Yes' : 'No'}</span>
          </div>
          <ToggleSwitch checked={formData.requireApproval} onChange={(val) => updateField('requireApproval', val)} />
        </div>

        <div className="flex items-center justify-between border border-gray-200 p-2.5 rounded-md h-14 bg-white">
          <div>
            <p className="text-xs font-semibold text-gray-800">Lock rota after publication?</p>
            <span className="text-[11px] text-gray-400">{formData.lockAfterPublish ? 'Yes' : 'No'}</span>
          </div>
          <ToggleSwitch checked={formData.lockAfterPublish} onChange={(val) => updateField('lockAfterPublish', val)} />
        </div>

        {/* Special Dates / Events Form Field Integration */}
        <div className="h-14">
          <label className="block text-[10px] uppercase font-bold text-gray-400 mb-1">Special Dates / Events</label>
          <input 
            type="text"
            placeholder="e.g. Bank Holiday, Private Event..."
            className="w-full text-xs p-2 border border-gray-300 rounded-md bg-white focus:outline-none placeholder-gray-300 text-gray-700"
            value={formData.specialDatesEvents}
            onChange={(e) => updateField('specialDatesEvents', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default Step6Settings;
